"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Input = _interopRequireDefault(require("../Input"));

var _Box = _interopRequireDefault(require("../Box"));

var _Typography = require("../Typography");

var _Menu = _interopRequireDefault(require("../Menu"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Svg = _styledComponents["default"].svg.withConfig({
  displayName: "Select__Svg",
  componentId: "sc-1oms462-0"
})(["display:inline-block;font-size:inherit;height:1em;overflow:visible;vertical-align:-0.125em;transform:rotate(90deg);"]);

var Icon = function Icon(_ref) {
  var props = _extends({}, _ref);

  return _react["default"].createElement(Svg, _extends({
    "aria-hidden": "true",
    focusable: "false",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512"
  }, props), _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
  }));
};

var Placeholder = function Placeholder(_ref2) {
  var props = _extends({}, _ref2);

  return _react["default"].createElement(_Typography.Text, _extends({
    color: "secondary"
  }, props));
};

var SelectEl = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "Select__SelectEl",
  componentId: "sc-1oms462-1"
})(["position:relative;cursor:pointer;display:inline-flex;align-items:center;&[diabled]{cursor:normal;}"]);
var Select = (0, _react.forwardRef)(function (_ref3, ref) {
  var Icon = _ref3.icon,
      value = _ref3.value,
      onChange = _ref3.onChange,
      placeholder = _ref3.placeholder,
      children = _ref3.children,
      name = _ref3.name,
      _ref3$onFocus = _ref3.onFocus,
      onFocusFromProps = _ref3$onFocus === void 0 ? function () {} : _ref3$onFocus,
      _ref3$onBlur = _ref3.onBlur,
      onBlurFromProps = _ref3$onBlur === void 0 ? function () {} : _ref3$onBlur,
      props = _objectWithoutProperties(_ref3, ["icon", "value", "onChange", "placeholder", "children", "name", "onFocus", "onBlur"]);

  var _useSelectLogic = useSelectLogic({
    value: value,
    children: children,
    name: name,
    onChange: onChange
  }),
      open = _useSelectLogic.open,
      options = _useSelectLogic.options,
      displayValue = _useSelectLogic.displayValue,
      selectRef = _useSelectLogic.selectRef,
      selectWidth = _useSelectLogic.selectWidth,
      handleSelectClick = _useSelectLogic.handleSelectClick,
      handleSelectKeyPress = _useSelectLogic.handleSelectKeyPress,
      handleSelectKeyDown = _useSelectLogic.handleSelectKeyDown,
      handleMenuClose = _useSelectLogic.handleMenuClose;

  var _useFocusBlurLogic = useFocusBlurLogic({
    onFocusFromProps: onFocusFromProps,
    onBlurFromProps: onBlurFromProps
  }),
      containerRef = _useFocusBlurLogic.containerRef,
      portalRef = _useFocusBlurLogic.portalRef,
      handleSelectFocus = _useFocusBlurLogic.handleSelectFocus;

  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(SelectEl, _extends({
    tabIndex: 0,
    ref: (0, _react.useCallback)(function (el) {
      if (typeof ref === 'function') ref(el);
      if (ref && _typeof(ref) === 'object') ref.current = el;
      containerRef.current = el;
      selectRef.current = el;
    }, []),
    as: "div",
    minHeight: 36,
    onClick: handleSelectClick,
    onKeyPress: handleSelectKeyPress,
    onKeyDown: handleSelectKeyDown,
    onFocus: handleSelectFocus
  }, props), _react["default"].createElement(_Box["default"], {
    flex: "1",
    px: 2
  }, placeholder && !value && _react["default"].createElement(Placeholder, null, placeholder), displayValue), _react["default"].createElement(_Typography.Text, {
    mr: 2,
    color: "secondary"
  }, _react["default"].createElement(Icon, null))), _react["default"].createElement(_Menu["default"], {
    maxHeight: 200,
    overflowY: "auto",
    width: selectWidth,
    open: open,
    onClose: handleMenuClose,
    target: selectRef.current,
    position: _constants.Position.BOTTOM_LEFT,
    portalRef: portalRef
  }, options));
});
Select.defaultProps = {
  width: 176,
  icon: Icon
};
var _default = Select;
exports["default"] = _default;

var useSelectLogic = function useSelectLogic(_ref4) {
  var value = _ref4.value,
      children = _ref4.children,
      name = _ref4.name,
      onChange = _ref4.onChange;
  var selectRef = (0, _react.useRef)();
  var optionsRef = (0, _react.useRef)({});

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      selectWidth = _useState4[0],
      setSelectWidth = _useState4[1]; // Focus an option when menu is opened (selects the selected one, or the first
  // one if none is selected)


  (0, _react.useEffect)(function () {
    if (!open) return;
    var optionToFocus = optionsRef.current[value] || Object.values(optionsRef.current)[0];
    globalThis.optionToFocus = optionToFocus;
    if (!optionToFocus) return; // For some reason, doing the focus in the same tick shoots the page scroll to the top,
    // this "run on next tick hack" works around it

    setTimeout(function () {
      optionToFocus.focus();
    }, 100);
  }, [open]); // Closes menu

  var handleMenuClose = function handleMenuClose() {
    setOpen(false);
  }; // Opens menu; saves select width


  var handleSelectClick = function handleSelectClick() {
    setSelectWidth(selectRef.current.clientWidth);
    setOpen(true);
  }; // On enters key press, opens menu


  var handleSelectKeyPress = function handleSelectKeyPress(ev) {
    var isEnterKeyPressed = [ev.which, ev.keyCode, ev.characterCode].includes(13);
    if (!isEnterKeyPressed) return;
    setOpen(true);
  };

  var handleSelectKeyDown = function handleSelectKeyDown(ev) {
    var isUpArrowKeyDowned = [ev.which, ev.keyCode, ev.characterCode].includes(38);
    var isDownArrowKeyDowned = [ev.which, ev.keyCode, ev.characterCode].includes(40);
    var isSpacebarKeyDowned = ev.keyCode === 32;
    if (!isUpArrowKeyDowned && !isDownArrowKeyDowned && !isSpacebarKeyDowned) return;
    ev.preventDefault();
    setOpen(true);
  }; // Calls onChange with selected value; closes menu


  var handleOptionClick = function handleOptionClick(value) {
    setOpen(false);
    onChange({
      target: {
        value: value,
        name: name
      }
    }, value);
    selectRef.current.focus();
  }; // On enter key press, selects the value and bring back the focus to the closed select element


  var handleOptionKeyPress = function handleOptionKeyPress(value) {
    return function (ev) {
      var isEnterKeyPressed = [ev.which, ev.keyCode, ev.characterCode].includes(13);
      if (!isEnterKeyPressed) return;
      handleOptionClick(value);
      selectRef.current.focus();
    };
  }; // Handles up arrow, down arrow, tab, and escape key downs


  var handleOptionKeyDown = function handleOptionKeyDown(value) {
    return function (ev) {
      var isUpArrowKeyDowned = [ev.which, ev.keyCode, ev.characterCode].includes(38);
      var isDownArrowKeyDowned = [ev.which, ev.keyCode, ev.characterCode].includes(40);
      var isTabKeyDowned = [ev.which, ev.keyCode, ev.characterCode].includes(9);
      var isEscKeyDowned = [ev.which, ev.keyCode, ev.characterCode].includes(27);
      var isSpacebarKeyDowned = ev.keyCode === 32; // Prevent scroll on space key down, and select the focused option instead,
      // to emulate the browser select behavior

      if (isSpacebarKeyDowned) {
        ev.preventDefault();
        handleOptionClick(value);
        selectRef.current.focus();
      } // Focus on prev/next option on up/down key down


      if (isUpArrowKeyDowned || isDownArrowKeyDowned) {
        ev.preventDefault();
        var refArr = Object.values(optionsRef.current);
        var indexWithFocus = refArr.findIndex(function (el) {
          return el === document.activeElement;
        });
        var indexToFocusNext = isUpArrowKeyDowned ? indexWithFocus - 1 : indexWithFocus + 1;
        var optToFocusNext = refArr[indexToFocusNext];
        if (optToFocusNext) optToFocusNext.focus();
      } // Do nothing on tab/shift+tab, imitating the browser select behavior.
      // This also prevents focusing into elements outside the select component
      // (which would be somewhere at the end of page [not good UX], due to the\
      // fact that <Menu /> uses React Portals)


      if (isTabKeyDowned) {
        ev.preventDefault();
      } // Close menu and bring back the focus to select element, on escape


      if (isEscKeyDowned) {
        handleMenuClose();
        selectRef.current.focus();
      }
    };
  };

  var optionsProps = _react["default"].Children.map(children, function (c) {
    return c.props;
  }) || [];

  var _ref5 = optionsProps.find(function (p) {
    return p.value === value;
  }) || {},
      displayValue = _ref5.children; // Clone children options and inject select logic props


  var options = _react["default"].Children.map(children, function (c) {
    return _react["default"].cloneElement(c, {
      selected: c.props.value === value,
      onClick: handleOptionClick,
      onKeyPress: handleOptionKeyPress(c.props.value),
      onKeyDown: handleOptionKeyDown(c.props.value),
      ref: function ref(el) {
        optionsRef.current[c.props.value] = el;
      }
    });
  });

  return {
    open: open,
    options: options,
    displayValue: displayValue,
    selectRef: selectRef,
    selectWidth: selectWidth,
    handleSelectClick: handleSelectClick,
    handleSelectKeyPress: handleSelectKeyPress,
    handleSelectKeyDown: handleSelectKeyDown,
    handleMenuClose: handleMenuClose
  };
};

var useFocusBlurLogic = function useFocusBlurLogic(_ref6) {
  var onFocusFromProps = _ref6.onFocusFromProps,
      onBlurFromProps = _ref6.onBlurFromProps;

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      hasFocus = _useState6[0],
      setHasFocus = _useState6[1];

  var _useOnClickOutside = useOnClickOutside(function () {
    if (!hasFocus) return;
    onBlurFromProps();
    setHasFocus(false);
  }, [onBlurFromProps]),
      containerRef = _useOnClickOutside.containerRef,
      portalRef = _useOnClickOutside.portalRef;

  return {
    containerRef: containerRef,
    portalRef: portalRef,
    handleSelectFocus: (0, _react.useCallback)(function () {
      // If `hasFocus` is true at this point, it means that it was the option element that had the
      // previous focus. This means, from consumer's POV, the focus hasn't left the Select component
      // so don't call `onFocus` again
      if (hasFocus) return;
      onFocusFromProps();
      setHasFocus(true);
    }, [hasFocus])
  };
};

var useOnClickOutside = function useOnClickOutside(callback, callbackDeps) {
  var _useState7 = (0, _react.useState)(0),
      _useState8 = _slicedToArray(_useState7, 2),
      listenCount = _useState8[0],
      setListenCount = _useState8[1];

  var containerRef = (0, _react.useRef)();
  var portalRef = (0, _react.useRef)(); // We want to do it `once` otherwise click and focusin could call it consecutively

  var memoCallback = (0, _react.useMemo)(function () {
    return once(callback);
  }, [].concat(_toConsumableArray(callbackDeps), [listenCount]));
  (0, _react.useEffect)(function () {
    var handler = function handler(ev) {
      if (!isElClickedInEv(containerRef.current, ev) && !isElClickedInEv(portalRef.current, ev)) {
        memoCallback(ev);
      } else {
        // When clicked/focusined inside again, we want to reset the `once` limit on callback so
        // that it runs again on next clicked/focusined outside
        setListenCount(function (curr) {
          return curr + 1;
        });
      }
    };

    window.addEventListener('click', handler);
    window.addEventListener('focusin', handler);
    return function () {
      window.removeEventListener('click', handler);
      window.removeEventListener('focusin', handler);
    };
  }, [memoCallback]);
  return {
    containerRef: containerRef,
    portalRef: portalRef
  };
};

var isElClickedInEv = function isElClickedInEv(el, ev) {
  return !!(el && (el.contains(ev.target) || ev.target === el));
};

var once = function once(fn) {
  var hasCalled = false;
  return function () {
    if (hasCalled) return;
    hasCalled = true;
    return fn.apply(void 0, arguments);
  };
};